module.exports = __webpack_public_path__ + "static/media/starfish 1.1.aab767e6.svg";